import { Injectable } from '@angular/core';
import pages from '../../../assets/data/configuration.json';
import { Configuration } from '../models/configuration.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
    private config: Configuration = new Configuration();

    constructor(private http: HttpClient) {
        // this.config = <Configuration>pages;
    }

    getSettings() {
        return this.config;
    }

    getJSONwithAPI() {
        return this.http.get<Configuration>(
            `../../../assets/data/configuration.json`
        );
    }

    // Method to fetch the configuration.json file
    getConfiguration(): Observable<any> {
        return this.http.get<any>(`../../../assets/data/configuration.json`); // Adjust the path if needed
    }

    getCountryDialCodes(): Observable<any> {
        return this.http.get('../../../assets/data/country-dial-code.json');
    }

    getCityToCountryMapping(): Observable<any> {
        return this.http.get('../../../assets/data/city-to-country.json');
    }
}
